let id = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 * @param prefix The value to prefix the ID with.
 */
export default function uniqueId(prefix = '') {
    id++;
    return `${prefix}${id}`;
}
//# sourceMappingURL=uniqueId.js.map